import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import type { TFunction } from 'ricos-types';

import { LoaderIcon, RemoveIcon } from '../../assets/icons';
import type { PollsMember } from '../../types';
import { withRCEHelpers } from '../rce-helpers-context';
import styles from './voted-users.rtlignore.scss';
import VoterAvatar from './VoterAvatar';

type Props = {
  fetchVoters: (args: {
    cursor?: string;
    limit: number;
  }) => Promise<{ voters: { memberId: string }[]; moreItems: boolean }>;
  option: {
    count: number;
    anonymousCount: number;
  };
  onRequestClose: () => void;
  t: TFunction;
  rce: {
    getSiteMembers: (memberIds: string[]) => Promise<PollsMember[]>;
  };
};

export class VotedUsersModalComponent extends Component<
  Props,
  {
    members: PollsMember[];
    moreItems: boolean;
    cursor?: string;
  }
> {
  state = {
    members: [] as PollsMember[],
    moreItems: true,
    cursor: undefined,
  };

  fetchVoters = async () => {
    const { cursor } = this.state;

    try {
      const { voters, moreItems } = await this.props.fetchVoters({ cursor, limit: 10 });
      const members = (await this.props.rce.getSiteMembers(voters.map(v => v.memberId))) || [];

      this.setState({
        members: this.state.members.concat(members),
        cursor: voters[voters.length - 1].memberId,
        moreItems,
      });
    } catch (error) {}
  };

  render() {
    const { t, option, onRequestClose } = this.props;
    const { members, moreItems } = this.state;

    return (
      <div className={styles.voted_users_modal}>
        <div className={styles.voted_users_modal_header}>
          <p className={styles.title}>
            {t('Poll_Viewer_VoteCount_Modal_Voters_Header', {
              count: option.count,
              number: option.count,
            })}
          </p>
          <RemoveIcon onClick={onRequestClose} className={styles.close_icon} />
        </div>
        <InfiniteScroll
          className={styles.member_list_container}
          initialLoad
          hasMore={moreItems}
          loadMore={this.fetchVoters}
          loader={
            <div className={styles.loader}>
              <LoaderIcon width={24} height={24} className={styles.spinner} />
            </div>
          }
        >
          <ul className={styles.member_list}>
            {members.map(member => {
              return member ? (
                <li key={member.siteMemberId}>
                  <div className={styles.user_card}>
                    <VoterAvatar
                      className={styles.user_avatar}
                      member={member}
                      src={member.imageUrl}
                      size={{
                        width: 36,
                        height: 36,
                      }}
                    />
                    <span className={styles.user_name}>
                      {member.name?.nick || t('Poll_Viewer_VoteCount_Modal_Voters_Private_Voter')}
                    </span>
                  </div>
                </li>
              ) : null;
            })}
          </ul>
        </InfiniteScroll>
        {option.anonymousCount ? (
          <p className={styles.anonymous_counter}>
            {t('Poll_Viewer_VoteCount_Modal_Voters_Anonymous', {
              anonNumber: option.anonymousCount,
            })}
          </p>
        ) : null}
      </div>
    );
  }
}

export const VotedUsersModal = withRCEHelpers(VotedUsersModalComponent);
